module.exports = __webpack_public_path__ + "static/img/Joe-Berry.2ed7a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Berry.jpg
// module id = V1hb
// module chunks = 0